import { api } from "../lib";
import { INTERNAL_RENDER_ROUTES } from "../lib/internalRenderAuth";
import type { ReportRenderContext } from "../types/reportRenderContext";

export const LEGACY_RECONSTRUCTION_RENDER_CONTEXT =
  "/legacy-reconstruction-render/context";
export const LEGACY_RECONSTRUCTION_RENDER_TOKEN_HEADER =
  "x-legacy-reconstruction-render-token";

export interface ReportRenderSubject {
  signOffId?: string;
  reconstructionId?: string;
}

export function fetchReportRenderContext(
  subject: ReportRenderSubject,
  token: string
): Promise<ReportRenderContext> {
  return subject.reconstructionId
    ? api.get<ReportRenderContext>(LEGACY_RECONSTRUCTION_RENDER_CONTEXT, {
        headers: { [LEGACY_RECONSTRUCTION_RENDER_TOKEN_HEADER]: token },
      })
    : api.get<ReportRenderContext>(INTERNAL_RENDER_ROUTES.context);
}

export function matchesReportRenderSubject(
  context: ReportRenderContext,
  subject: ReportRenderSubject
): boolean {
  if (!subject.signOffId && !subject.reconstructionId) return false;
  if (!Array.isArray(context.diagnosisCategories)) return false;
  if (!subject.reconstructionId) return context.signOffId === subject.signOffId;
  const snapshot = context.reportRenderSnapshot;
  const supplemental = snapshot?.supplementalData;
  return (
    context.reconstructionId === subject.reconstructionId &&
    context.reportVersion === 0 &&
    Boolean(
      snapshot?.reportData?.legacyBaseline && supplemental?.previewData
    ) &&
    Array.isArray(supplemental?.pathologistComments) &&
    Array.isArray(supplemental?.reportAttachments?.images) &&
    Array.isArray(supplemental?.reportAttachments?.files)
  );
}
